import * as React from 'react';
import SpecForms from 'Specs/UI/ConnectedSpecForms';

const SpecsContents = () => {
  return <SpecForms />;
}

export default SpecsContents;
